import { Form, Field, ErrorMessage } from 'vee-validate'

export default function installVeeValidate(app) {
  app.component('VForm', Form)
  app.component('VField', Field)
  app.component('VErrorMessage', ErrorMessage)
}
